import { createRouter, createWebHistory } from "vue-router";

// 路由懒加载工厂函数
const lazyLoad = (view) => {
  return () =>
    import(/* webpackChunkName: "[request]" */ `../views/${view}.vue`);
};

const routes = [
  {
    path: "/",
    name: "home",
    component: lazyLoad("HomeView"),
  },
  {
    path: "/detail/:type/:id.html",
    name: "Detail",
    component: () =>
      import(/* webpackChunkName: "detail" */ "@/components/ShowDetail.vue"),
    props: true,
  },
  {
    path: "/about.html",
    name: "about",
    component: lazyLoad("AboutView"),
    meta: { preload: true },
  },
  {
    path: "/solution.html",
    name: "solution",
    component: lazyLoad("SolutionView"),
    meta: { preload: true },
  },
  {
    path: "/product.html",
    name: "product",
    component: lazyLoad("ProductView"),
    meta: { preload: true },
  },
  {
    path: "/project.html",
    name: "project",
    component: lazyLoad("UserCaseView"),
    meta: { prefetch: true },
  },
  {
    path: "/news.html",
    name: "news",
    component: lazyLoad("NewsView"),
    meta: { prefetch: true },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 路由加载时的预加载策略
router.beforeEach((to, from, next) => {
  // 对标记为预加载的路由进行资源预加载
  if (to.meta.preload) {
    // 可以在这里添加额外的预加载逻辑
  }
  next();
});

export default router;
